function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AppDependency = /*#__PURE__*/function () {
  function AppDependency() {
    _classCallCheck(this, AppDependency);

    if (!window.___appDependency) {
      window.___appDependency = this;
      window.___appDependencyList = [];
    }

    return window.___appDependency;
  }

  _createClass(AppDependency, [{
    key: "addItem",
    value: function addItem(moduleName) {
      window.___appDependencyList.push(moduleName);
    }
  }, {
    key: "addList",
    value: function addList(moduleNameList) {
      window.___appDependencyList = window.___appDependencyList.concat(moduleNameList);
    }
  }, {
    key: "get",
    value: function get() {
      return window.___appDependencyList;
    }
  }]);

  return AppDependency;
}();

export default new AppDependency();